<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card
          class="mx-auto d-print-none"
          style="border: darkgreen 2px solid;background-color: linen"
      >
        <v-card-title>
          <v-icon
              large
              left
          >
            mdi-file-edit
          </v-icon>
          <p>จัดการข้อมูลขอเสนอแผนอนุมัติงบประมาณประจำปี (<span
              style="font-weight: bold;color: #ff6d81">{{ appHeaderName }}</span>)</p>
          <v-spacer></v-spacer>
          <v-btn outlined :color="appColor" @click="$root.$refs.Train.ChooseProcess(TypeProject, true);">
            <span style="font-size: 20px">กลับเมนูหลัก</span>
          </v-btn>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
        </v-card-text>

        <v-card-actions class="justify-space-around">
          <v-list>
            <v-list-item>
              <v-row
                  class="justify-space-around"
              >
                <v-col align="center" col="12" md="12">
                  <v-btn
                      x-large
                      :outlined="menu.id == HeaderPage"
                      :text="menu.id != HeaderPage"
                      v-for="menu in Menu"
                      :key="menu.id"
                      :disabled="menu.disable"
                      :color="(menu.id == HeaderPage ? '#1E88E5' : '#607D8B')"
                      @click="goToPage(menu, true)">
                    <h3 style="font-weight: bold">{{ menu.value }}</h3>
                  </v-btn>
                  <hr/>
                </v-col>
              </v-row>
            </v-list-item>
            <v-list-item>
              <v-row
                  class="justify-space-around"
              >
                <v-col align="center" col="12" md="12">
                  <v-btn
                      x-large
                      :outlined="menu.id == PlanProjectPage"
                      :text="menu.id != PlanProjectPage"
                      v-for="menu in Menu2"
                      :key="menu.id"
                      :disabled="menu.disable"
                      :color="(menu.id == PlanProjectPage ? '#1E88E5' : '#607D8B')"
                      @click="goToPage(menu, false)">
                    <h3 style="font-weight: bold">{{ menu.value }}</h3>
                  </v-btn>
                  <hr/>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card-actions>

        <router-view></router-view>

      </v-card>
      <div class="d-none d-print-block">
        <router-view></router-view>
      </div>
    </template>
    <template>
      <v-dialog
          v-model="dialogProcess"
          max-width="1000"
          persistent>
        <v-card>
          <v-card-title>
            <span style="font-weight: bold">
              ขอเสนอแผนอนุมัติงบประมาณประจำปี
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt12">
            <row class="d-flex justify-center mt-12">
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="primary" @click="ChooseProcess('1')">
                  <span style="font-size: 20px">โครงการ</span>
                </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
              >
                <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2')">
                  <span style="font-size: 20px">อบรม / เดินทางไปปฏิบัติราชการ</span>
                </v-btn>
              </v-col>
            </row>
<!--            <v-list>
              <v-list-item>
                <row class="d-flex justify-center mt-12" style="width: 100%">
                  <v-col
                      cols="12"
                      class="d-flex justify-center"
                  >
                    <v-btn class="font-weight-bold pa-12" color="primary" @click="ChooseProcess('1', false)"  style="width: 100%">
                      <h2 class="d-none d-md-inline">โครงการ</h2>
                      <h5 class="d-sm-inline d-md-none">โครงการ</h5>
                    </v-btn>
                  </v-col>
                </row>
              </v-list-item>
              <v-list-item>
                <row class="d-flex justify-center mt-12" style="width: 100%">
                  <v-col
                      cols="12"
                      class="d-flex justify-center"
                  >
                    <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2', true)" style="width: 100%">
                      <h2 class="d-none d-md-inline">อบรม / เดินทางไปปฏิบัติราชการ (ผ่าน HR)</h2>
                      <h5 class="d-sm-inline d-md-none">อบรม / เดินทางไปปฏิบัติราชการ (ผ่าน HR)</h5>
                    </v-btn>
                  </v-col>
                </row>
              </v-list-item>
              <v-list-item>
                <row class="d-flex justify-center mt-12" style="width: 100%">
                  <v-col
                      cols="12"
                      class="d-flex justify-center"
                  >
                    <v-btn class="font-weight-bold pa-12" color="#004D40" dark @click="ChooseProcess('2', false)" style="width: 100%">
                      <h2 class="d-none d-md-inline">อบรม / เดินทางไปปฏิบัติราชการ (ไม่ผ่าน HR)</h2>
                      <h5 class="d-sm-inline d-md-none">อบรม / เดินทางไปปฏิบัติราชการ (ไม่ผ่าน HR)</h5>
                    </v-btn>
                  </v-col>
                </row>
              </v-list-item>
            </v-list>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" @click="dialogProcess = false" dark class="font-weight-bold">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading.....
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogChooseProcess"
          max-width="800">
        <v-card>
          <v-card-title class="font-weight-bold">
            <span v-if="TypeProject == '1'" style="color: black">โครงการ : เลือกเมนูที่ต้องการทำรายการ</span>
            <span v-else style="color: black">อบรม/เดินทางไปปฏิบัติงาน : เลือกเมนูที่ต้องการทำรายการ</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <template v-if="(TypeProject == null || TypeProject == '1')">
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-content>
                  <v-btn  text x-large  @click="goToPage2('/Propose_a_plan/PlanProject')">
                    <span style="color: black;font-size: 16px;font-weight: bold">ข้อมูลขอเสนอแผนอนุมัติงบประมาณประจำปี</span>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-content>
                  <v-btn  text x-large  @click="goToPage2('/Propose_a_plan/InsertPlanProject')">
                    <span style="color: black;font-size: 16px;font-weight: bold">เสนอแผนอนุมัติงบประมาณประจำปี</span>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-content>
                  <v-btn  text x-large  @click="goToPage2('/Propose_a_plan/EditPlanProject')">
                    <span style="color: black;font-size: 16px;font-weight: bold">แก้ไขข้อมูลขอเสนอแผนอนุมัติงบประมาณประจำปี</span>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <template v-else>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-icon>
                  <v-icon>mdi-view-grid-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link to="/ManageProject/Project">
                    <span style="color: black;font-size: 16px;font-weight: bold">ข้อมูลจัดอบรม/เดินทางไปปฏิบัติราชการ</span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                  style="background-color: white"
              >
                <v-list-item-icon>
                  <v-icon>mdi-view-grid-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <router-link to="/ManageProject/InsertProject">
                    <span style="color: black;font-size: 16px;font-weight: bold">จัดอบรม/เดินทางไปปฏิบัติราชการ</span>
                  </router-link>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark class="font-weight-bold" @click="dialogChooseProcess = false" color="red">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Const from "@/const/Const";

export default {
  name: "ManageProject",
  data() {
    return {
      page: null,
      dialogChooseProcess: false,
      dialogLoading: false,
      process: null,
      dialogProcess: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      CheckAdmin: false,
      CheckSubAdmin: false,
      Menu: [
        {
          id: '0',
          value: 'ขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan',
          disable: false
        },
        {
          id: '1',
          value: 'จัดโครงการ / เดินทางไปปฏิบัติราชการ',
          page: '/ManageProject',
          disable: false
        },
        {
          id: '2',
          value: 'เข้าร่วมโครงการ',
          page: '/JoinProject',
          disable: false
        }
      ],
      Menu2: [
        {
          id: '0',
          value: 'ข้อมูลขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan/PlanProject',
          disable: true
        },
        {
          id: '1',
          value: 'เสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan/InsertPlanProject',
          disable: true
        },
        {
          id: '2',
          value: 'แก้ไขข้อมูลขอเสนอแผนอนุมัติงบประมาณประจำปี',
          page: '/Propose_a_plan/EditPlanProject',
          disable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      HeaderPage: 'Project/getHeaderPage',
      PlanProjectPage: 'Project/getPlanProjectPage',
      TypeProject: 'Project/getTypeProject',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
      projPlanMenu: 'Page/getProjPlanMenu',
      // dialogLoading: 'Page/getDialogLoading',
    }),
    // dialogLoading: {
    //   // getter
    //   get: function () {
    //     return this.$store.state.Page.appDialogLoading
    //   },
    //   // // setter
    //   // set: function (newValue) {
    //   // this.$store.commit('updateMessage', value)
    //   // }
    // }
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      changeTypeProject: 'Project/changeTypeProject',
      changeHeaderPage: 'Project/changeHeaderPage',
      changePlanProjectPage: 'Project/changePlanProjectPage',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeProjPlanMenu: 'Page/changeProjPlanMenu',
      // changeDialogLoading: 'Page/changeDialogLoading',
    }),
    goToPage: function (param, checkMenu) {
      if (checkMenu) {
        this.changeHeaderPage({
          page: param.id
        })
        this.changePlanProjectPage({
          page: null
        })
      } else {
        this.changeHeaderPage({
          page: this.HeaderPage
        })
        this.changePlanProjectPage({
          page: param.id
        })
      }
      this.$router.push(param.page)
    },
    goToPage2: function (param) {
      this.$router.push(param)
      this.dialogChooseProcess = false
    },
    init() {
      this.initMeData().then(res => {
        if (res) {
          this.initDateForPlan().then(res => {
            if (res) {
              this.checkProcess()
            }
          }).catch(res => {
            if (res) {
              console.log(res)
            }
          })
        }
      })
    },
    checkProcess() {
      if (this.page != null) {
        if (this.DateForPlan.filter(item => item.date_start <= this.getDateNow() && item.date_end >= this.getDateNow()).length > 0) {
          this.Menu2[0].disable = false
          this.Menu2[1].disable = false
          this.Menu2[2].disable = false
        } else {
          this.Menu2[0].disable = false
          // this.Menu2[1].disable = true
          // this.Menu2[2].disable = true
          this.Menu2[1].disable = false
          this.Menu2[2].disable = false
        }
      } else {
        this.Menu2[0].disable = true
        this.Menu2[1].disable = true
        this.Menu2[2].disable = true
      }
    },
    getDateNow() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      if (hour.toString().length == 1) {
        hour = '0' + hour;
      }
      if (minute.toString().length == 1) {
        minute = '0' + minute;
      }
      if (second.toString().length == 1) {
        second = '0' + second;
      }
      return yyyy + '-' + mm + '-' + dd
    },
    ChooseProcess(page) {
      this.page = null
      this.page = page
      this.changeHeaderPage({
        page: '0'
      })
      this.changePlanProjectPage({
        page: null
      })
      if (page == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
        this.$router.push('/Propose_a_plan')
        this.dialogProcess = false
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
        this.$router.push('/Propose_a_plan')
        this.dialogProcess = false
      }
      this.checkProcess()
      this.dialogChooseProcess = true
    }
    /*ChooseProcess(page, hr_cordi) {
      this.page = null
      this.page = page
      this.changeHeaderPage({
        page: '0'
      })
      this.changePlanProjectPage({
        page: null
      })
      if (page == '1') {
        this.changeTypeProject({
          type: '1',
          hr: hr_cordi,
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: 'โครงการ พัฒนาตนเอง / อื่น ๆ'
        })
        this.$router.push('/Propose_a_plan')
        this.dialogProcess = false
      } else {
        this.changeTypeProject({
          type: '2',
          hr: hr_cordi,
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: hr_cordi ? 'อบรม / เดินทางไปปฏิบัติราชการ (ผ่าน HR)' : 'อบรม / เดินทางไปปฏิบัติราชการ (ไม่ผ่าน HR)'
        })
        this.$router.push('/Propose_a_plan')
        this.dialogProcess = false
      }
      this.checkProcess()
    }*/
  },
  mounted() {
    this.changeHeaderPage({
      page: '0'
    })
    this.changePlanProjectPage({
      page: null
    })
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    if (this.$route.path == '/ManageProject/PlanProject') {
      this.changeProjPlanMenu('0')
    } else if (this.$route.path == '/ManageProject/InsertPlanProject') {
      this.changeProjPlanMenu('1')
    } else if (this.$route.path == '/ManageProject/EditPlanProject') {
      this.changeProjPlanMenu('2')
    }
    // this.changeColor({
    //   color: '#004D40'
    // })
    this.dialogLoading = true
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '6'
        })
        this.getMenuPermissData().then(async res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '6' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.getPermissionData({
                perid: this.MeData[0].perid
              }).then(resAdmin => {
                if (resAdmin) {
                  this.PermissionAdmin.map((Per_i, idx) => {
                    if (Per_i.permission_id == '10000') {
                      this.CheckAdmin = true
                      // this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                      this.ChooseProcess('1')
                      this.dialogChooseProcess = true
                      this.dialogLoading = false
                      this.init()
                    } else {
                      this.dialogLoading = false
                      if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                        this.$router.push('/')
                      }
                    }
                  })
                } else {
                  this.getPermissionUserData({
                    perid: this.MeData[0].perid
                  }).then(resUser => {
                    if (resUser) {
                      this.Permission.map((Per_i, idx) => {
                        if (Per_i.permission_id == '10000') {
                          this.CheckSubAdmin = true
                          // this.TypeProject == null ? this.dialogProcess = true : this.ChooseProcess(this.TypeProject)
                          this.ChooseProcess('1')
                          this.dialogChooseProcess = true
                          this.dialogLoading = false
                          this.init()
                        } else {
                          this.dialogLoading = false
                          if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                            this.$router.push('/')
                          }
                        }
                      })
                    } else {
                      this.dialogLoading = false
                      this.CheckSubAdmin = false
                      this.CheckAdmin = false
                      this.$router.push('/')
                    }
                  })
                }
              })
            } else {
              this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '6' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
              this.maintain = true
            }
          }
        }).then(err => {
          if (err) {
            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '6' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '6')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
            this.maintain = true
          }
        })
      }
    }).catch(reason => {
      this.dialogLoading = false
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>
